import { NotificationButton } from 'ia-react-core';
import styled from 'styled-components';

export const StyledNotificationButton = styled(NotificationButton)`
  width: 66px !important;  
`;
